import './styles.scss'

import React from 'react'
import { connect } from 'kea'
import PropTypes from 'prop-types'

import courseLogic from '~/scenes/course/show/logic'

const logic = connect({
  props: [courseLogic, ['course']]
})

export const Overlay = ({ course: { visibleRates, membershipRate } }) => {
  return (
    <div className='class-rates-float'>
      {visibleRates.map(visibleRate => (
        <div className='visible-rate' key={visibleRate.location}>
          <strong>{visibleRate.title}</strong>
          <table className='smallinfotable'>
            <tbody>
              {visibleRate.rates.map(rates => (
                <tr key={rates.duration}>
                  <td className='rate-title'>{rates.title}</td>
                  <td className='rate-price'>{rates.price}</td>
                  {rates.discount ? <td className='rate-discount'>{rates.discount}</td> : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
      {membershipRate ? <div className='membership-rate'>{membershipRate}</div> : null}
    </div>
  )
}

Overlay.propTypes = {
  course: PropTypes.array,
  membershipRate: PropTypes.string
}

export default logic(Overlay)
